export const insideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/wL1bNEefX7YJK52hgxoCnT/Captura_de_pantalla_2026-10-04_030324.png',
    alt: 'Inside page: Class 09 — Adductor & groin mobility sequence',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vLS1GTydmgYce8nrZimpwC/Captura_de_pantalla_2026-10-04_030230.png',
    alt: 'Inside page: Level up without forcing flexibility — the 7-step progression ladder',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jVJABFiHCXs9NTQygZkbpe/Captura_de_pantalla_2026-10-04_030148.png',
    alt: 'Inside page: Same movement, three options — beginner, standard and advanced',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rPgGcxowbJc34swkcXbTwN/Captura_de_pantalla_2026-10-04_030044.png',
    alt: 'Inside page: Class 16 — Full-body dynamic flow',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bnsJhvKtc2gecEAuc4Ap7U/Captura_de_pantalla_2026-10-04_030020.png',
    alt: 'Inside page: Class 25 — Complete dynamic mobility class timeline',
  },
]
